import { useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2 } from 'lucide-react';

const GPUInstanceDetailTasks = () => {
  const { instanceId } = useParams<{ instanceId: string }>();

  return (
    <div className="container py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Instance Tasks</h1>
        <p className="text-muted-foreground mt-1">
          View task history for this instance
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Task History</CardTitle>
          <CardDescription>
            All tasks executed on this GPU instance
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Alert>
            <AlertDescription>
              No tasks have been executed on this instance yet.
            </AlertDescription>
          </Alert>
        </CardContent>
      </Card>
    </div>
  );
};

export default GPUInstanceDetailTasks;
